export default function IconAdd({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 18.5714 18.5714"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7143 1.42857C10.7143 0.639593 10.0747 0 9.28571 0C8.49674 0 7.85714 0.639593 7.85714 1.42857V7.85714H1.42857C0.639593 7.85714 0 8.49674 0 9.28571C0 10.0747 0.639593 10.7143 1.42857 10.7143H7.85714V17.1429C7.85714 17.9319 8.49674 18.5714 9.28571 18.5714C10.0747 18.5714 10.7143 17.9319 10.7143 17.1429V10.7143H17.1429C17.9319 10.7143 18.5714 10.0747 18.5714 9.28571C18.5714 8.49674 17.9319 7.85714 17.1429 7.85714H10.7143V1.42857Z"
        fill="currentColor"
      />
    </svg>
  )
}
